import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { getUnionPayPayout } from '@/models/settlements/ports'
import { PadInfo } from '@/features/Pad'
import { parseErrorMessage } from '@/ports/api'

type Error = {
  message: string
}

const getData = async (): Promise<PadInfo> => {
  try {
    const data = await getUnionPayPayout()
    if (!data?.response.ok) {
      const message = parseErrorMessage(data?.body)
      throw message
    }
    return data?.body?.payout
  } catch (err) {
    if (typeof err === 'string' && err.startsWith('bank data not found')) return {} as PadInfo
    throw err
  }
}

const useDirectDeposit = (
  config?: Omit<UseQueryOptions<PadInfo, Error>, 'queryKey' | 'queryFn'>
): UseQueryResult<PadInfo, Error> =>
  useQuery<PadInfo, Error>({
    queryKey: ['settlements', 'direct_deposit'],
    queryFn: () => getData(),
    staleTime: 5 * 60000,
    ...config
  })

export default useDirectDeposit
